var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-4" },
    [
      _c("h4", { staticClass: "mb-2" }, [_vm._v("Submit A Ticket")]),
      _c(
        "b-container",
        {
          staticClass: "px-5 d-flex justify-content-center",
          attrs: { "bg-variant": "success" },
        },
        [
          _c(
            "b-form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Requester",
                            "label-for": "h-first-Requester",
                            "label-cols-md": "4",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "h-Requester",
                              type: "Email",
                              placeholder: "Email",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Subject",
                            "label-for": "h-Subject",
                            "label-cols-md": "4",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "h-Subject",
                              type: "text",
                              placeholder: "Subject",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Product / Service",
                            "label-for": "h-Product",
                            "label-cols-md": "4",
                          },
                        },
                        [
                          _c("b-form-select", {
                            attrs: { options: _vm.product },
                            model: {
                              value: _vm.selected,
                              callback: function ($$v) {
                                _vm.selected = $$v
                              },
                              expression: "selected",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Priority",
                            "label-for": "h-Priority",
                            "label-cols-md": "4",
                          },
                        },
                        [
                          _c("b-form-select", {
                            attrs: { options: _vm.priority },
                            model: {
                              value: _vm.selected,
                              callback: function ($$v) {
                                _vm.selected = $$v
                              },
                              expression: "selected",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Description",
                            "label-for": "h-Description",
                            "label-cols-md": "4",
                          },
                        },
                        [
                          _c("quill-editor", {
                            attrs: { options: _vm.snowOption },
                            model: {
                              value: _vm.content,
                              callback: function ($$v) {
                                _vm.content = $$v
                              },
                              expression: "content",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { "offset-md": "4" } },
                    [
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "ripple",
                              rawName: "v-ripple.400",
                              value: "rgba(255, 255, 255, 0.15)",
                              expression: "'rgba(255, 255, 255, 0.15)'",
                              modifiers: { 400: true },
                            },
                          ],
                          staticClass: "mr-1",
                          attrs: { type: "submit", variant: "primary" },
                        },
                        [_vm._v(" Submit ")]
                      ),
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "ripple",
                              rawName: "v-ripple.400",
                              value: "rgba(186, 191, 199, 0.15)",
                              expression: "'rgba(186, 191, 199, 0.15)'",
                              modifiers: { 400: true },
                            },
                          ],
                          attrs: {
                            type: "reset",
                            variant: "outline-secondary",
                          },
                        },
                        [_vm._v(" Reset ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }